import { adminHttpClient } from '../commons/adminHttpClient'

export type SendTestEmailRequest = {
  templateId: string
}

const sendTestEmail = (request: SendTestEmailRequest) => adminHttpClient.post('Csi/SentTestEmail', request)

export default sendTestEmail
